import React, { useState, useEffect } from 'react'
import './HeaderStatsStyles.css'
import firebase from '../Firebase'
import { FiCheck, FiX } from 'react-icons/fi'

function HeaderStats() {
  const [solutionStats, setSolutionStats] = useState(null)


  useEffect(() => {
    firebase.firestore().collection('stats').doc('solutions').get()
    .then(doc => {
      if(doc.exists) {
        setSolutionStats(doc.data())
      }
    })
  }, [])
   return solutionStats && (
        <div className='solution-stats'>
          <p><FiCheck className='check' /> {solutionStats.successful}</p>
          <p><FiX className='wrong'/> {solutionStats.fails}</p>
        </div>
  )
}

export default HeaderStats
